import React from 'react';
import { Link } from 'react-router-dom';

interface SentantiaLogoProps {
  link?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showSubtitle?: boolean;
}

const SUBTITLE = 'Litigation Intelligence';

export default function SentantiaLogo({
  link = true,
  size = 'md',
  className = '',
  showSubtitle = true,
}: SentantiaLogoProps) {
  const sizes = {
    sm: { text: 'text-[22px]', gap: 'gap-1.5', ruleH: 'h-[2px]', sub: 'text-[8px]' },
    md: { text: 'text-xl', gap: 'gap-1', ruleH: 'h-px', sub: 'text-[8px]' },
    lg: { text: 'text-4xl', gap: 'gap-1.5', ruleH: 'h-[2px]', sub: 'text-[11px]' },
  };

  const s = sizes[size];
  const isLight = className.includes('light') || className.includes('navy');

  // The wordmark defines the lockup width; the rule and the subtitle are
  // forced to exactly that width (w-0 + min-w-full keeps them from
  // contributing intrinsic width, and the subtitle's letters are spread
  // with justify-between so the tagline spans edge to edge).
  const content = (
    <div className={`inline-flex flex-col items-stretch ${s.gap} ${className}`}>
      <div
        aria-hidden="true"
        className={`${s.ruleH} w-0 min-w-full ${isLight ? 'bg-white/80' : 'bg-navy-900/40'}`}
      />
      <span
        className={`font-serif font-bold tracking-tight leading-none whitespace-nowrap text-center ${
          isLight ? 'text-white' : 'text-navy-900'
        } ${s.text}`}
      >
        SENTANTIA
      </span>
      {showSubtitle && (
        <span
          aria-label={SUBTITLE}
          className={`w-0 min-w-full flex justify-between leading-none uppercase font-sans font-medium ${
            isLight ? 'text-white/70' : 'text-paper-500'
          } ${s.sub}`}
        >
          {SUBTITLE.split('').map((ch, i) => (
            <span key={i} aria-hidden="true">
              {ch === ' ' ? '\u00A0' : ch}
            </span>
          ))}
        </span>
      )}
    </div>
  );

  return link ? <Link to="/dashboard" className="shrink-0">{content}</Link> : content;
}
